import React, { useEffect, useState } from "react";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { CircularProgress, Container, Typography, Box } from "@mui/material";
import config from "../config.js";

function WorkbookDisplay() {
  const [workbookData, setWorkbookData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { API_BASE_URL } = config;

  ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(
          `${API_BASE_URL}/api/v1/workbookToJson`
        );
       
        
        // Handle the data structure properly
        if (response.data && response.data.data && response.data.data.Sheet1) {
          setWorkbookData(response.data.data);
        } else if (response.data && response.data.Sheet1) {
          setWorkbookData(response.data);
        } else {
          console.error("Unexpected data structure:", response.data);
          setError(new Error("Unexpected data structure from API"));
        }
      } catch (error) {
        console.error("API error:", error);
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  if (isLoading) {
    return (
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Typography variant="h6" color="error">
          Error: {error.message}
        </Typography>
      </Container>
    );
  }

  // Check if we have valid data to render
  if (!workbookData || !workbookData.Sheet1 || workbookData.Sheet1.length === 0) {
    return (
      <Container>
        <Typography variant="h6">
          No data available. Please check the API response structure.
        </Typography>
        <Box mt={2}>
          <Typography variant="body2" component="pre" sx={{ backgroundColor: "#f5f5f5", p: 2, overflowX: "auto" }}>
            {JSON.stringify(workbookData, null, 2)}
          </Typography>
        </Box>
      </Container>
    );
  }

  // Determine the correct column names from the first item
  const firstItem = workbookData.Sheet1[0];
  const categories = Object.keys(firstItem).find(key => 
    key.toLowerCase().includes('category') || 
    key.toLowerCase().includes('budget') || 
    key.toLowerCase().includes('personal')
  ) || Object.keys(firstItem)[0];
  
  const amounts = Object.keys(firstItem).find(key => 
    key.toLowerCase().includes('amount') || 
    key.toLowerCase().includes('value') || 
    key.toLowerCase().includes('empty')
  ) || Object.keys(firstItem)[1];

  // Prepare chart data
  const chartData = {
    labels: workbookData.Sheet1.map(item => item[categories] || "Unknown"),
    datasets: [
      {
        label: "Budget Amount",
        data: workbookData.Sheet1.map(item => parseFloat(item[amounts]) || 0),
        backgroundColor: [
          'rgba(75, 192, 192, 0.6)',
          'rgba(54, 162, 235, 0.6)',
          'rgba(255, 206, 86, 0.6)',
          'rgba(255, 99, 132, 0.6)',
          'rgba(153, 102, 255, 0.6)'
        ],
        borderColor: [
          'rgba(75, 192, 192, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(255, 99, 132, 1)',
          'rgba(153, 102, 255, 1)'
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Personal Finance Budget',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Amount'
        }
      },
      x: {
        title: {
          display: true,
          text: 'Categories'
        }
      }
    }
  };

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Personal Budget 
      </Typography>
      <Box
        sx={{
          padding: "20px",
          width: "100%",
          height: "400px",
          
        }}
      >
        <Bar data={chartData} options={options} />
      </Box>
      
    
   
    </Container>
  );
}

export default WorkbookDisplay;
